const PRODUCTION = window.location.port !== "8080";
export default PRODUCTION;
